export default __webpack_public_path__ + "static/media/men_perfum.f94bc268.jpg";